import { View, Text, TouchableOpacity } from "react-native";
import React, { useEffect } from "react";
import Icon from "react-native-vector-icons/Feather"; // ใช้ Feather icons
// import { useNavigationState } from "@react-navigation/native"; // ✅ ใช้เช็คหน้าปัจจุบัน
import { useRouter } from "expo-router";
import { useLanguage } from "./screens/LanguageProvider"; // ใช้เพื่อแปลภาษา
import { usePathname } from "expo-router"; // ใช้เพื่อเช็ค path ปัจจุบัน

interface MenuItemProps {
  icon: string;
  label: string;
  active?: boolean;
  onPress: () => void;
}

export default function Menubar() {
  const router = useRouter();
  const { t } = useLanguage(); // ใช้เพื่อแปลภาษา
  const pathname = usePathname();

  return (
    <View className="absolute bottom-0 left-0 right-0 flex-row justify-around items-center bg-white py-3 px-4 mx-6 mb-16 border border-gray-100 shadow-lg rounded-full">
      <MenuItem icon="home" label={t("home")} active={pathname === "/screens/home"} onPress={() => router.push("/screens/home")} />
      <MenuItem icon="printer" label={t("order_print")} active={pathname === "/screens/orderprint"} onPress={() => router.push("/screens/orderprint")} />
      <MenuItem icon="user" label={t("profile")} active={pathname === "/screens/menuprofile"} onPress={() => router.push("/screens/menuprofile")} />
    </View>
  );
}

const MenuItem: React.FC<MenuItemProps> = ({ icon, label, active = false, onPress }) => (
  <TouchableOpacity className="items-center" onPress={onPress}>
    <Icon name={icon} size={24} color={active ? "#F17736" : "#999"} />
    <Text className={`text-xs font-kanit mt-1 ${active ? "text-[#F17736]" : "text-gray-400"}`}>{label}</Text>
  </TouchableOpacity>
);